import * as React from 'react';
import { SDKSettingsResponse, defaultSDKSettingsResponse } from '@ul/common';

export type SDKSettingsContext = {
    // can add more from other sources\
} & SDKSettingsResponse;

export const defaultSDKSettingsContext = {
    ...defaultSDKSettingsResponse,
};

export const SDKSettingsContext = React.createContext<SDKSettingsContext>(defaultSDKSettingsContext);
